module.exports = __webpack_public_path__ + "static/media/online-teaching-img3.5a2da0e0.jpg";